import React from 'react'
import { TablePlugin } from '../../../../plugins/components/TablePlugin'
import { useGetSymptomsOfAllergiesQuery } from '../../../../services/rtk-query/clinicalApi'

export const Lista = ({ columns }) => {
  const { data, isFetching } = useGetSymptomsOfAllergiesQuery()
  return (
    <>
      <TablePlugin data={data ?? []} columns={columns} isFetching={isFetching} />
    </>
  )
}
